<div class="flex flex-col gap-4 flex-1 overflow-y-auto px-4 pt-4 pb-4">
  <div class="template-new-section flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <span class="ds-overline template-muted">{{ '#CORE_FILTER.TEMPLATES.NEW' | translate }}</span>
      <soft-ds-input [(value)]="newName"
                   size="lg"
                   [placeholder]="'#CORE_FILTER.TEMPLATES.NAME_PLACEHOLDER' | translate"
                   data-testid="filter-template-name-input">
      </soft-ds-input>
    </div>
    <soft-ds-button variant="outline"
                    size="lg"
                    class="w-full"
                    [disabled]="!newName()?.trim()"
                    (click)="create()"
                    data-testid="filter-template-create">
      {{ '#CORE_FILTER.TEMPLATES.CREATE_FROM_DRAFT' | translate }}
    </soft-ds-button>
  </div>

  <div class="template-list flex flex-col">
    @for (template of templateService.sortedTemplates(); track template.id) {
    <div class="template-card flex flex-col gap-2" data-testid="filter-template-card">
      <div class="flex items-center gap-2 min-h-8">
        @if (renamingId() === template.id) {
          <soft-ds-input [(value)]="renameValue"
                         size="md"
                         class="flex-1"
                         data-testid="filter-template-rename-input">
          </soft-ds-input>
          <soft-ds-button mode="iconOnly" variant="ghost" size="sm"
                          (click)="confirmRename()"
                          data-testid="filter-template-rename-confirm">
            <soft-icon name="fa-regular fa-check" />
          </soft-ds-button>
          <soft-ds-button mode="iconOnly" variant="ghost" size="sm"
                          (click)="cancelRename()"
                          data-testid="filter-template-rename-cancel">
            <soft-icon name="fa-regular fa-xmark" />
          </soft-ds-button>
        }
        @else {
          <span class="ds-body-2-semibold truncate">{{ template.name }}</span>
          @if (template.scope === 'system') {
            <soft-ds-badge variant="outline" size="sm">{{ '#CORE_FILTER.TEMPLATES.SYSTEM' | translate }}</soft-ds-badge>
          }
          @else if (template.scope === 'team') {
            <soft-ds-badge variant="outline" size="sm">{{ '#CORE_FILTER.TEMPLATES.TEAM' | translate }}</soft-ds-badge>
          }
          @if (template.readonly) {
            <soft-ds-icon name="fa-regular fa-lock" size="xs" class="template-muted" />
          }
          @if (templateService.displayedActive()?.id === template.id) {
            <span class="template-active ds-overline">{{ '#CORE_FILTER.TEMPLATES.ACTIVE' | translate }}</span>
          }
          <soft-ds-button mode="iconOnly" variant="ghost" size="sm"
                          class="ml-auto"
                          [aria-label]="'#CORE_FILTER.TEMPLATES.FAVORITE' | translate"
                          (click)="toggleFavorite(template)"
                          data-testid="filter-template-favorite">
            <soft-ds-icon [name]="template.favorite ? 'fa-solid fa-star' : 'fa-regular fa-star'"
                          size="xs"
                          class="template-star" />
          </soft-ds-button>
        }
      </div>
      <div class="flex items-center gap-1">
        <soft-ds-button variant="ghost-primary" size="sm"
                        (click)="applyTemplate(template)"
                        data-testid="filter-template-apply">
          {{ '#CORE_FILTER.TEMPLATES.APPLY' | translate }}
        </soft-ds-button>
        <soft-ds-button variant="ghost" size="sm"
                        (click)="duplicate(template)"
                        data-testid="filter-template-duplicate">
          {{ '#CORE_FILTER.TEMPLATES.DUPLICATE' | translate }}
        </soft-ds-button>
        @if (!template.readonly) {
          <soft-ds-button variant="ghost" size="sm"
                          (click)="startRename(template)"
                          data-testid="filter-template-rename">
            {{ '#CORE_FILTER.TEMPLATES.RENAME' | translate }}
          </soft-ds-button>
          <soft-ds-button variant="ghost-destructive" size="sm"
                          (click)="remove(template)"
                          data-testid="filter-template-delete">
            {{ '#CORE_FILTER.TEMPLATES.DELETE' | translate }}
          </soft-ds-button>
        }
      </div>
    </div>
  }
    @empty {
      <p class="ds-body-2 template-muted">{{ '#CORE_FILTER.TEMPLATES.EMPTY' | translate }}</p>
    }
  </div>
</div>
